module.exports = __webpack_public_path__ + "img/m4.504c0132.png";